import "antd/dist/reset.css";
import { Collapse, Descriptions } from "antd";
import React from "react";
import utils from "utils";
import "./SOSSummaryChild.scss";

const { Panel } = Collapse;

const DiagnosiSummaryChild = (props) => {

  return (
    <>
      {props.data?.completion_date? (
        <Collapse
          style={{ overflowY: "auto" }}
          bordered={false}
          // expandIconPosition="start"
          ghost={true}
          // className="mhe-list-container"
          collapsible="icon"
          defaultActiveKey={[1]}
        >
          <Panel
          className={props.showDate?"headerHiddenPanel":""} 
            header={
              (props.showDate)&& <div>
                {utils.FormatDate(props?.data?.completion_date, "DATE_14")},{" "}
                {utils.FormatDate(props?.data?.completion_date, "TIME_1")}
              </div>
            }
            extra={(props.showDate)&&<div>{utils.FirstNameLastName(utils.salutationPrefixName(props?.data?.doctor_salutation, utils.getDisplayName(props?.data?.consultation_doctor, props?.data?.doctor_last_name)), "250px")}</div>}
            key="1"
            showArrow={false}
          >
             <div key={props.data?.completion_date} className="main-header">{props.data?.title}</div>
            {/* <Descriptions
            bordered
            layout="horizontal"
            column={1}
            labelStyle={{ width: "50%" }}
            > */}
            {Object.entries(props.data).map(([sumKey, sumVal], index) => {
               if ( Array.isArray(sumVal) && sumVal.length > 0) {  
                 if(sumKey === "final_diagnosis_check_box"){
                  return (props.data["final_diagnosis"]?.length === 0 ) &&  <div className="final-diagnosis-summary"><label>{sumVal.filter((val)=>val.is_selected).length > 0 ? "* Note: Selected options to enable final diagnosis" : ""}</label><ul> {sumVal.filter((val)=>val.is_selected).map((val)=> <div><li>{utils.ConvertToPascalCase(val.name.trim())}</li></div>)}</ul></div>
                 }
                 else{
                  return (
                  <Descriptions
                    // bordered
                    layout="horizontal"
                    column={1}
                    // labelStyle={{ width: "50%" }}
                    labelStyle={{ width: "20%"}}
                    >
                      <Descriptions.Item key={index} label={utils.ConvertToPascalCase(sumKey)}>{<ul style={{ listStyleType:"none", }}>{sumVal.map((val,i)=>{if(val && val.length >0) return <li key={i}> {utils.ConvertToPascalCase(val.trim())} </li>})}</ul>}</Descriptions.Item>
                  </Descriptions>
                  )
                 }
                // return <Descriptions.Item key={index} label={utils.ConvertToPascalCase(sumKey)}>{<ul>{sumKey=="final_diagnosis_check_box"? sumVal.map((val,i)=>{if(sumVal.length>0 && val.is_selected) return <li key={i}> {utils.ConvertToPascalCase(val.name.trim())} </li>}): sumVal.map((val,i)=>{if(val.trim()) return <li key={i}> {utils.ConvertToPascalCase(val.trim())} </li>})}</ul>}</Descriptions.Item>;
              }
            })}
            {/* </Descriptions>             */}
          </Panel>
        </Collapse>
      ) : null}
    </>
  );
};

export default DiagnosiSummaryChild;
